import { NoteTextIcon } from './NoteTextIcon';

/**
 * author: Austin Andrews
 * id 2ADC4253-F51B-4BC2-B04C-0DDD139425CF
 * name note-text
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-text.svg
 * tags
 */
export const PostItNoteTextIcon = NoteTextIcon;
export default PostItNoteTextIcon